export default __webpack_public_path__ + "static/media/bg_login_create.831885f3.svg";